import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "./UserContext";

interface ProtectedRouteProps {
  roles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles }) => {
  const { state } = useUserContext();
  const { role } = state;

  if (!role || !roles.includes(role)) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
